import React from 'react';
import './cpSlideProductImg.less';
import classnames from 'classnames';

export default class SlideProductImg extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      slide: false, //enter active leave
      imgUrl: '',
      left: '',
      top: '',
    };
  }
  componentDidMount() {
    const { imgEl, targetEl, imgUrl } = this.props;
    if (imgEl && imgUrl && targetEl) {
      const info = imgEl.getBoundingClientRect();
      this.setState({
        left: info.left - 1,
        top: info.top - 1,
        imgUrl: imgUrl,
      }, () => {
        const targetInfo = targetEl.getBoundingClientRect();
        this.setState({
          left: targetInfo.left + targetInfo.width / 2,
          top: targetInfo.top + targetInfo.height / 2,
          slide: true
        });
      });
    }
  }
  componentWillUnmount() {
    this.setState = () => false;
  }
  onTransitionEnd = () => {
    const { onLeave } = this.props;
    onLeave && onLeave();
  }
  render() {
    const { imgUrl, left, top, slide } = this.state;
    return (
      <>
        {imgUrl ? <div
          className={classnames({
            "cp-slide-img-container": true,
            'slide': slide
          })}
          style={{
            position: 'fixed',
            left,
            top,
          }}
          onTransitionEnd={this.onTransitionEnd}
        ><img src={imgUrl} alt='' /></div> : null}
      </>
    );
  }
}
